// Check if an element is visible, including its parents
// Note: also has a js version in rails/app/assets/javascripts/lib/isElementVisible/index.js
export const isElementVisible = (element: Element): boolean => {
  const style = window.getComputedStyle(element)
  if (style.display === "none" || style.visibility === "hidden") {
    return false
  }

  let parent = element.parentElement
  while (parent) {
    const parentStyle = window.getComputedStyle(parent)
    if (parentStyle.display === "none" || parentStyle.visibility === "hidden") {
      return false
    }
    parent = parent.parentElement
  }

  return true
}
